<alert type="info">
  <!-- <a href="https://www.boe.ca.gov/prop19/" target="_blank">
    <alert type="info">
      {{ "Prop19.Prop19Infov2" | translate }}
    </alert>

  </a> -->
  <!-- <p style="margin-top: .8rem"><strong>IMPORTANT:</strong> To receive Homeowner Alert Service (e-Notification), <a ngbPopover="Temporarily Disabled" triggers="mouseenter:mouseleave" >register today</a> and select the <strong><i>Opt-In for AIN/Recorded Document email notification</i></strong></p> -->
  <!-- <p style="margin-top: .8rem"><strong>IMPORTANT:</strong> To receive Homeowner Alert Service (e-Notification), <a [href]="envService.loginUrl" target="_blank">register today</a> and select the <strong><i>Opt-In for AIN/Recorded Document email notification</i></strong></p> -->
  <p style="margin-top: .8rem" [innerHTML]="'HomeownerAlertPage.Importantv2'|translate:{ registerUrl: envService.getSsoRegisterUrl() }"></p>
</alert>

<app-leveltwo [pageName]="'E-Notifications'">
  <div class="General">
    <h3>{{ "HomeownerAlertPage.Title" | translate }}</h3>
    <h4>{{ "e-Notification" | translate }}</h4>
    <p>{{ "Newsletter.AlertDescv2" | translate }} </p>
    <div style="display: flex; gap: 10px">
      <a [class]="buttonClass" [ngbTooltip]="buttonToolTip" [attr.href]="siteConfigService.isENotificationDisabled() ? null : envService.getSsoRegisterUrl()" target="_blank">
        <span>{{ "Home.RegisterToday" | translate }}</span>
      </a>
      <a [class]="buttonClass"
        [ngbTooltip]="buttonToolTip"
        (click)="goToENotification()">
        <span>{{ "Existing Users" | translate }}</span>
      </a>
      <a class="btn btn-primary" [ngbTooltip]="buttonToolTip" href="https://res.cloudinary.com/los-angeles-county-assessor/image/upload/v1790448792/Msc/ASSR_eNotification_Guide.pdf" target="_blank">
        <span>{{ "HomeownerAlertPage.InstructionsGuide" | translate }}</span>
      </a>
    </div>
  </div>

</app-leveltwo>
